import React, { Fragment } from 'react';
import KycDisplay from './KycDisplay';

export default function KycConfirmation({
  kyc,
  onRevealSuccess,
  onRevealFail,
  token,
}: {
  kyc: Kyc;
  onRevealSuccess: () => void;
  onRevealFail: () => void;
  token: string;
}): React.JSX.Element {
  return (
    <Fragment>
      <div className='md:flex mb-5'>
        <div className='md:w-full my-2'>
          <p className='confirmation-page-heading'>Financial Representative</p>
        </div>
      </div>
      <KycDisplay
        kyc={kyc}
        onRevealSuccess={onRevealSuccess}
        onRevealFail={onRevealFail}
        token={token}
      />
    </Fragment>
  );
}
